import React from 'react'

interface CottonCandyContainerProps {
  children: React.ReactNode
}

export function CottonCandyContainer ({ children }: CottonCandyContainerProps) {
  return (
    <div className='bg-white border border-emphasis shadow-emphasis rounded-2xl'>
      {children}
    </div>
  )
}
